// extracted by mini-css-extract-plugin
export default {"content":"FinancialDashboard_content__obtio","title":"FinancialDashboard_title__7eJBC","skeletonLoadingAnimation":"FinancialDashboard_skeletonLoadingAnimation__HDcd8"};